<template>
	<div class="page">
		<div class="form">
			<div class="available-amount">
				<span class="label">剩余可用额度：</span>
				<span class="value">{{ availableAmount }}</span>
			</div>
			<div class="form-item">
				<div class="label">注入底池金额：</div>
				<el-input v-model="input.price" placeholder="请输入金额"></el-input>
			</div>
			<div class="form-item">
				<div class="label">
					<span>备</span>
					<span>注：</span>
				</div>
				<el-input v-model="input.remark" placeholder="请输入备注"></el-input>
			</div>
			<div>
				<el-button type="danger" @click="handleClearAll">清盘</el-button>
				<el-button type="primary" @click="handleRegulation">提交</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { regulation, clearAll, getAvailableAmount } from "@/api/vbao.js";
	export default {
		data() {
			return {
				availableAmount: "--",
				input: {
					price: "",
					remark: "",
				},
			};
		},
		mounted() {
			this.fetchAvailableAmount();
		},
		methods: {
			fetchAvailableAmount() {
				getAvailableAmount().then((res) => {
					if (res.success && res.code === 200) {
						this.availableAmount = res.availableAmount;
					}
				});
			},
			handleRegulation() {
				let { price, remark } = this.input;
				regulation({
					regulationAmount: Number(price),
					remark,
				}).then((res) => {
					if (res.success) {
						this.input.price = "";
						this.input.remark = "";
						this.fetchAvailableAmount();
						this.$message({
							message: "提交成功！",
							type: "success",
						});
					} else {
						this.$message({
							message: res.msg,
							type: "warning",
						});
					}
				});
			},
			handleClearAll() {
				let message = `<div style='user-select: none;'>
					<p style='margin-bottom: 10px;'>此操作不可逆，会清空所有v宝相关数据。</p>
					<p style='margin-bottom: 10px;'>清空所有v宝和v小宝，按当前价格返还消费券给用户，重置底池到初始状态。</p>
					<p>确认系统清盘请输入<strong style='color: #ff2121;'>CONFIRM_CLEAR_ALL</strong>。</p>
				</div>`;
				let title = "警告";
				let options = {
					inputPattern: /^CONFIRM_CLEAR_ALL$/,
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					dangerouslyUseHTMLString: true,
				};
				this.$prompt(message, title, options)
					.then(() => {
						clearAll({ confirmCode: "CONFIRM_CLEAR_ALL" }).then((res) => {
							if (res.success) {
								this.fetchAvailableAmount();
								this.$message({
									type: "success",
									message: "系统清盘成功!",
								});
							} else {
								this.$message({
									type: "warning",
									message: res.msg,
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消系统清盘",
						});
					});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.page {
		padding: 20px;
		background-color: #fff;
		font-size: 14px;
	}

	.form {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 20px;

		.available-amount {
			align-self: normal;
			font-size: 16px;
			font-weight: 500;
			color: #303133;

			.value {
				color: #409eff;
			}
		}

		.form-item {
			display: flex;
			align-items: center;
			align-self: normal;
			.label {
				width: 8em;
				display: flex;
				justify-content: space-around;
			}
		}
	}
</style>
